/**
 * <Student />
 *
 * This is student page. Mostly it only comprises of Tabs. It handles
 * UI redux to record the
 *
 * @since caspian
 * @parent routes
 * @children
 * @stateful
 * @redux

 */
import React, { PropTypes } from 'react';
import { MenuItem, Dropdown } from 'react-bootstrap'
import { hotline } from 'vendor/react-redux-hotline';
import { browserHistory } from 'react-router'
import EnrollClass from 'template/Modals/EnrollClass';
import ExportModal from 'template/Modals/Export';
import __R, { userCan } from 'containers/__R';

import {
  Button,
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel,
  CountBadge
} from 'components/UI'
import './Student.scss';
import iPadGuide from 'template/Modals/iPadGuide';
import { alert } from 'util/alert';
import DefaultTab from "./DefaultTab";
import FilterBy from 'template/FilterBy';
import CreateStudentModal from 'template/Modals/CreateStudent'
import locale from './locale';
import {getSubscription} from 'containers/Main/ducks/subscription';

const DEFAULT_TAB_INDEX = 0;

class Student extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: DEFAULT_TAB_INDEX,
      filterData: {
        searchKeyword: this.props.student.searchStudentKeyword || ''
      },
      orderBy: 0
    };

    this.onSearch = this.onSearch.bind(this);

    this._onSelectTab = this._onSelectTab.bind(this);
    this._enrollMultipleStudentsToClass = this._enrollMultipleStudentsToClass.bind(this);
    this._archiveMultipleStudents = this._archiveMultipleStudents.bind(this);
    this.exportStudentList = this.exportStudentList.bind(this);
  }

  componentWillReceiveProps(nextProps){
    const { dispatch } = this.props;
    const schoolId = localStorage.getItem('schoolId');

    if(this.props.student.currentCount && this.props.student.currentCount !== nextProps.student.currentCount){
      dispatch(getSubscription(schoolId));
    }

  }

  onSearch({ filterData }) {
    const { studentState } = this.props.student;
    const { orderBy } = this.state;

    this.setState({
      filterData,
    }, ()=>{
      this.props.student.fetchStudent('@onSearch()', studentState, {}, filterData.searchKeyword, orderBy);
    });
  }

  _enrollMultipleStudentsToClass() {
    const {
      student
    } = this.props;
    const { 
      orderBy,
    } = this.state;
    const {
      studentSelectedByCheckbox,
      studentState,
    } = student;

    EnrollClass({ students: studentSelectedByCheckbox })
    .then(({ updateRequired: updateStudentTableRequired })=>{
      if (updateStudentTableRequired) {
        student.fetchStudent('After editing classes @enroll-student-to-class', studentState, {}, '', orderBy);
        this.forceUpdate();
      }
    })
    .catch((err)=>{
      console.error(err);
    });
  }

  _archiveMultipleStudents() {
    let { student } = this.props

    student.archiveMultipleSelectedStudents()
  }

  _onSelectTab(tabIndex) {
    this.setState({
      filterData: {
        ...this.state.filterData,
        searchKeyword: this.props.student.searchStudentKeyword || '',
      },
      tabIndex,
    });
  }

  exportStudentList(format) {
    ExportModal({
      type: 'student',
      title: 'Export Student List',
      format: format
    })
  }

  renderAddStudentButton(){
    const { gSubscription } = this.props;
    const {maximum_amount, existing_amount, saas_version, is_valid} = gSubscription.result;
    const {maximum_student} = maximum_amount;
    const {student_amount} = existing_amount;
    const { orderBy } = this.state;

    return(
      <__R can='create_student' by='disable'>
        <button className='btn btn-primary' onClick={()=>{
          console.log('saas_version', is_valid)
          if(is_valid && (saas_version === 1 || maximum_student === null || student_amount < maximum_student)){
            CreateStudentModal({mode: 'create'})
            .then(({ result, student }) => {
              if (result === 'success') {
                const { studentState } = this.props.student;
                this.props.student.fetchStudent('after edit student', studentState, {}, '', orderBy);
              }
            })
            .catch(() => {})
          }else{
            alert.message(__('You are about go over the student limit, please upgrade to higher subscription plan to add more students', 'header'), __('Upgrade Subscription Plan', 'header'))
          }

        }}>{__("New Student", "student")}</button>
      </__R>
    )
  }

	render() {
    const schoolId = localStorage.getItem('schoolId');
    const { student, gSubscription } = this.props;
    const { currentCount, studentList, fetching, studentState, } = student;
    const {tabIndex, filterData, orderBy} = this.state;
    const Filter = (
      <FilterBy
        filterData={filterData}
        filters={['text:searchKeyword']}
        options={{
          'text:searchKeyword': {
            placeholder: __('Search name...', 'student'),
            valueMinLength: 2,
          }
        }}
        disabled={fetching}
        schoolId={schoolId}
        onChange={this.onSearch} />
    );

    return (
      <PanelWrapper className='student-panel'>
        <div>
					{__("Student List", "student")}
        </div>
				<Tabs defaultIndex={DEFAULT_TAB_INDEX} onSelect={this._onSelectTab}>
					<TabList id='tab-list'>
            <Tab>
              {__("Registered", "student")}
              { studentState == 'all_not_archived' && fetching !== true && <CountBadge>{currentCount}</CountBadge> }
            </Tab>
						<Tab>
              {__("Not Enrolled", "student")}
              { studentState == 'not_enrolled' && fetching !== true && <CountBadge>{currentCount}</CountBadge> }
            </Tab>
						<Tab>
              {__("Enrolled", "student")}
              { studentState == 'enrolled' && fetching !== true && <CountBadge>{currentCount}</CountBadge> }
            </Tab>
						<Tab>
              {__("Pending Renewal", "student")}
              { studentState == 'pending_renewal' && fetching !== true && <CountBadge>{currentCount}</CountBadge> }
            </Tab>
						<Tab>
              {__("Archived", locale)}
              { studentState == 'archived' && fetching !== true && <CountBadge>{currentCount}</CountBadge> }
            </Tab>
            <div className='setting-section pull-right'>
            <div className='sort-by-label'>{__('Sort by', locale)}</div>
            <select className='form-control sort-by'
              onChange={(e) => {
                this.props.student.fetchStudent('@onSearch()', studentState, {}, filterData.searchKeyword, e.target.value);
            }}>
              <option key='0' value='0'>{__('Creation Time: Newest to Oldest', locale)}</option>
              <option key='5' value='5'>{__('Creation Time: Oldest to Newest', locale)}</option>
              <option key='1' value='1'>{__('Last Name: A-Z', locale)}</option>
              <option key='2' value='2'>{__('Last Name: Z-A', locale)}</option>
              <option key='3' value='3'>{__('First Name: A-Z', locale)}</option>
              <option key='4' value='4'>{__('First Name: Z-A', locale)}</option>
            </select>
            {Filter}
              { !gSubscription.fetching && this.renderAddStudentButton()}
            <Dropdown  id='setting-dropdown' >
              <Dropdown.Toggle className='expand-to-right expand-to-down'>
                <i className='fa icon-cog' style={{marginRight: 5}}></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem eventKey="student-settings" onSelect={()=>{
                  browserHistory.push('/student-settings')
                }} disabled={!userCan('edit_school_setting')}>{__('Student Custom Fields','studentTable')}</MenuItem>
                <MenuItem eventKey="export-student" onSelect={()=>browserHistory.push('/import-student')} disabled={!userCan('create_student') || !userCan('edit_school_setting')}>{__('Import Students','studentTable')}</MenuItem>
                <MenuItem eventKey="export-student" onSelect={()=>this.exportStudentList('excel')} disabled={!userCan('export_student')}>{__('Export Student List to Excel','teacherAttendance')}</MenuItem>
                <MenuItem eventKey="export-student" onSelect={()=>this.exportStudentList('csv')} disabled={!userCan('export_student')}>{__('Export Student List to CSV','teacherAttendance')}</MenuItem>
                <MenuItem eventKey="export-student" onSelect={()=>{ iPadGuide(); }} >{__("Registration Guide", "student")}</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          </TabList>

          

          <TabPanel>
            <DefaultTab studentState='all_not_archived' orderBy={orderBy} filterData={filterData}/>
          </TabPanel>

          <TabPanel>
            <DefaultTab studentState='not_enrolled' orderBy={orderBy} filterData={filterData}/>
          </TabPanel>

          <TabPanel>
            <DefaultTab studentState='enrolled' orderBy={orderBy} filterData={filterData}/>
          </TabPanel>

          <TabPanel>
            <DefaultTab studentState='pending_renewal' orderBy={orderBy} filterData={filterData}/>
          </TabPanel>

          <TabPanel>
            <DefaultTab studentState='archived' orderBy={orderBy} filterData={filterData} />
          </TabPanel>
        </Tabs>
			</PanelWrapper>
    );
  }
}

export default hotline(Student, 'student', 'gSubscription');



// WEBPACK FOOTER //
// ./src/containers/pages/Student/index.js